import { createSyncAction, IBaseAction } from '@bimser/core';
import * as ActionTypes from './actionTypes';
import {
	IOpenMessageBoxPayload,
	OpenMessageBoxPayloadFactoryFromJS,
	IMessageBoxButton
} from '../entities';

export default function openMessageBoxTransactionAction(
	data: IOpenMessageBoxPayload
): IBaseAction<any> {
	const action = createSyncAction(
		ActionTypes.OPEN_MESSAGEBOX_TRANSACTION_ACTION,
		OpenMessageBoxPayloadFactoryFromJS(data)
	);

	return action;
}
